import type { Currency } from '@weft/types';
import { formatNumber } from '@weft/utils';
import { Price } from 'apps/app/src/components/design/Price';
import type { ColumnDefinition } from 'apps/app/src/components/design/table/table-components/table-body/table-body-components/table-row/table-row-components/table-cell/table-cell-types/column-definition';
import { EMPTY_TIER_DATA } from './invoice-consts';
import type { CommitmentLineItemPerUnitRow } from './invoice-types/commitment-line-item-per-unit-row';

export function buildCommitmentLineItemPerUnitTableColumns(currency: Currency): ColumnDefinition<CommitmentLineItemPerUnitRow>[] {
  return [
    {
      header: 'Bulk price',
      headerClassName: 'text-center w-fit',
      renderCell: ({ rate }) => (
        <div className="flex justify-center">
          <Price currency={currency}>
            {rate}
          </Price>
        </div>
      ),
    },
    {
      header: 'Bulk size',
      headerClassName: 'text-center w-fit',
      renderCell: ({ chunkSize }) => (
        <p className='text-center'>
          {chunkSize}
        </p>
      ),
    },
    {
      header: 'YTD QTY',
      headerClassName: 'text-center w-fit',
      renderCell: ({ ytdUnits }) => {
        return (
          <p className='text-center'>
            {ytdUnits > 0 ? formatNumber(ytdUnits) : EMPTY_TIER_DATA}
          </p>
        );
      },
    },
    {
      header: 'Period QTY',
      headerClassName: 'text-center w-fit',
      renderCell: ({ periodUnits }) => (
        <p>
          {periodUnits > 0
            ? formatNumber(periodUnits)
            : EMPTY_TIER_DATA
          }
        </p>
      ),
    },
    {
      header: 'Billable QTY',
      headerClassName: 'text-center w-fit',
      renderCell: ({ billableUnits }) => (
        <p>
          {billableUnits > 0
            ? formatNumber(billableUnits)
            : EMPTY_TIER_DATA
          }
        </p>
      ),      
    },
    {
      header: 'Amount',
      headerClassName: 'text-center w-fit',
      renderCell: ({ billableUnits, price }) => (
        <div className="flex justify-center">
          <Price currency={currency}>
            {billableUnits > 0 ? price : EMPTY_TIER_DATA}
          </Price>
        </div>
      ),
    },
  ];
}